import { ActionContext } from "vuex";
interface StepperState {
    plateform:string,
    tags:string[],
    gender:unknown,
    age:unknown,
    origin:unknown,
    residence:unknown,
    city:unknown,
    followersCount:unknown,
    engagementRate:unknown,
    personReached:unknown,
    isSearchHandled:boolean,
    isSearchStarted:boolean,
    talents:[],
    selectedLanguage:string
  }
//import { createStore } from 'vuex';
const initState:StepperState = {
    plateform: "instagram",
    tags: [] ,
    gender: null as unknown,
    age: null as unknown,
    origin: null as unknown,
    residence: null as unknown,
    city: null as unknown,
    followersCount: null as unknown,
    engagementRate: null as unknown,
    personReached: null as unknown,
    isSearchHandled: false,
    isSearchStarted: false,
    talents: [],
    selectedLanguage:'en'
}

export const stepper = {
    namespaced: true,
    state: initState,
    actions: {
        setSelectedLanguage(context: ActionContext<StepperState, any>, language: string) {
            context.commit('storeSelectedLanguage', language);
          },      
    },
    mutations: {
        storePlateformType(state: any, plateform: string) {
            state.plateform = plateform;
        },
        storeTags(state: any, tags: string[]) {
            state.tags = tags;
        },
        storeGender(state: any, gender: any) {
            state.gender = gender;
        },
        storeAge(state: any, age: number) {
            state.age = age;
        },
        storeOrigin(state: any, origin: Set<string>) {
            state.origin = origin;
        },
        storeResidence(state: any, residence: string) {
            state.residence = residence;
        },
        storeCity(state: any, city: string) {
            state.city = city;
        },
        storeFollowersCount(state: any, followersCount: any) {
            state.followersCount = followersCount;
        },
        storeEngagementRate(state: any, engagementRate: any) {
            state.engagementRate = engagementRate;
        },
        storePersonReached(state: any, personReached: any) {
            state.personReached = personReached;
        },
        startSearch(state: any, isSearchStarted: boolean) {
            state.isSearchStarted = isSearchStarted
        },
        handleSearch(state: any, isSearchHandled: boolean) {
            state.isSearchHandled = isSearchHandled
        },
        resetState(state: any) {
            state.tags = [] as string[]
            state.age = null as unknown
            state.gender = null as unknown
            state.origin = null as unknown
            state.residence = null as unknown
            state.city = null as unknown
            state.followersCount = null as unknown
            state.engagementRate = null as unknown
            state.personReached = null as unknown
            state.isSearchHandled = false
            state.isSearchStarted = false
            state.talents = [] as any[]
            //Object.assign(state,initState)
        },
        storeTalents(state: any, talents: any[]) {
            state.talents = talents
        },
        refindState(state: any) {
            state.isSearchHandled = false
            state.talents = [] as any[]
        },
        setSelectedLanguage(state:any, language:string) {
            state.selectedLanguage = language;
          },
    },
    getters: {
        getTags: (state: any) => {
            return state.tags
        },
        getGender: (state: any) => {
            return state.gender
        },
        getAge: (state: any) => {
            return state.age
        },

        getOrigin: (state: any) => {
            return state.origin
        },
        getResidence: (state: any) => {
            return state.residence
        },
        getCity: (state: any) => {
            return state.city
        },
        getFollowersCount: (state: any) => {
            return state.followersCount
        },
        getEngagementRate: (state: any) => {
            return state.engagementRate
        },
        getPersonReached: (state: any) => {
            return state.personReached

        },
        selectedLanguage: (state:any) => state.selectedLanguage,


    },

}